/**
* Filter selector for revive experiences section
*
* This function create an selector
*
*/

export const results = (state) => state.reviveReducer;
export const resultsItems = (state) => state.reviveReducer.data.data;
